export default "__VITE_ASSET__D_68L$1a__"